module.exports = __webpack_public_path__ + "img/guidline.a5604685.svg";